module.exports = __webpack_public_path__ + "static/media/branding-img18.d21872e2.jpg";